import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_local_makers: FaireThemeEntity = {
  token: "discovery_theme_local-makers",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Local Makers Spotlight",
  description: "Discover emerging artisans and small brands",
  bgColor: "#D4F0E8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
